import req from './http.js';

// 定义接口
export const login = params => req('post', '/system/login', params, {
	baseURL: process.env.VUE_APP_URL,
}); // 登录
export const getValidateCode = params => req('post', '/system/getValidateCode', params, {
	baseURL: process.env.VUE_APP_URL,
}); // 图形验证码
export const Logout = params => req('post', '/system/logout', params, {
	baseURL: process.env.VUE_APP_URL,
}); // 退出登录
export const sendSms = params => req('post', '/system/sendSms', params, {
	baseURL: process.env.VUE_APP_URL,
}); // 发送短信验证码
export const getModuleMenu = params => req('post', '/system/getModuleMenu', params, {
	baseURL: process.env.VUE_APP_URL,
}); // 菜单
